var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m49.113 14.405-3.78 5.04h-.43l-3.696-5.058v8.438H39.02V11.223h2.52l3.629 4.988 3.63-4.988h2.503v11.602h-2.188v-8.42z",
    fill: "#81B141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.543 11.205h-2.172v11.603h2.172V11.205z",
    fill: "#81B141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.216 14.04a4.444 4.444 0 0 0-2.95-1.16c-2.487 0-3.996 1.889-3.996 4.277 0 1.899 1.112 3.878 3.996 3.878a3.86 3.86 0 0 0 2.619-.928v-2.056h-2.966v-1.956h4.972v4.89c-1.145 1.31-2.59 2.089-4.625 2.089-4.36 0-6.133-2.868-6.133-5.917 0-3.267 2.039-6.278 6.133-6.278 1.616 0 3.167.636 4.316 1.773l-1.366 1.388zM77.586 22.825v-4.69h-5.703v4.69h-2.188V11.223h2.188v4.89h5.703v-4.89h2.17v11.602h-2.17zM84.81 13.194h-3.68v-1.989h9.549v1.99h-3.68v9.613H84.81v-9.614z",
    fill: "#81B141"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m97.588 15.996 3.083-4.79h2.635v.1l-4.623 6.712v4.79h-2.19v-4.79l-4.458-6.713v-.1h2.602l2.95 4.791z",
    fill: "#81B141",
    stroke: "#81B141",
    strokeWidth: 0.57,
    strokeMiterlimit: 22.93
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.824 16.908c.048 2.935-1.742 5.9-5.803 5.9h-4.558V11.205h4.558c3.98 0 5.753 2.835 5.803 5.698v.005zm-8.186 3.795h2.383c2.637 0 3.681-1.923 3.626-3.812-.05-1.806-1.11-3.614-3.626-3.614h-2.383v7.426z",
    fill: "#363A57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.635 11.205h-2.172v11.603h2.172V11.205z",
    fill: "#363A57"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.308 14.04a4.442 4.442 0 0 0-2.949-1.16c-2.486 0-3.995 1.89-3.995 4.277 0 1.9 1.11 3.878 3.995 3.878a3.855 3.855 0 0 0 2.618-.927V18.05h-2.966v-1.956h4.974v4.89c-1.143 1.31-2.59 2.089-4.624 2.089-4.36 0-6.134-2.868-6.134-5.917 0-3.267 2.039-6.283 6.134-6.283 1.616 0 3.168.636 4.317 1.773l-1.37 1.394z",
    fill: "#363A57"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.959 11.205h-2.172v11.603h2.172V11.205z",
    fill: "#363A57"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.544 13.194h-3.681v-1.989h9.548v1.99h-3.686v9.613h-2.181v-9.614zM157.898 14.008c-.399-.663-1.492-1.293-2.753-1.293-1.624 0-2.403.678-2.403 1.542 0 1.01 1.193 1.291 2.59 1.457 2.417.298 4.674.929 4.674 3.696 0 2.59-2.288 3.697-4.874 3.697-2.369 0-4.194-.729-5.056-2.85l1.823-.945c.518 1.276 1.858 1.839 3.267 1.839 1.381 0 2.668-.48 2.668-1.74 0-1.094-1.143-1.542-2.685-1.707-2.371-.283-4.558-.913-4.558-3.515 0-2.386 2.353-3.365 4.489-3.38 1.806 0 3.679.518 4.558 2.303l-1.74.896z",
    fill: "#363A57"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.942 29.871a12.913 12.913 0 0 1-12.623-15.62v-.724l.13.173 4.164 5.698h.5l4.39-5.853v9.782h2.536V9.843h-2.906l-4.218 5.803-3.408-4.686-.808-1.117H3.228A15.446 15.446 0 0 0 30.38 24.565h-3.017a12.905 12.905 0 0 1-10.421 5.306z",
    fill: "#81B141"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.27 15.036A15.443 15.443 0 0 0 4.177 8.272h3.22a12.917 12.917 0 0 1 22.357 7.047c.158.659.19 1.341.097 2.012-.259 1.868-1.525 3.532-4.166 3.532H22.91v-8.632h2.773a4.439 4.439 0 0 1 2.306.576c-.238-1.5-.792-2.417-1.177-2.91a8.741 8.741 0 0 0-1.13-.073h-5.295V23.31h5.296a7.717 7.717 0 0 0 2.754-.471c2.458-.934 3.719-3.134 3.947-5.465a7.94 7.94 0 0 0-.114-2.338z",
    fill: "#363A57"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.957 33.913a16.957 16.957 0 1 1 16.956-16.956 16.974 16.974 0 0 1-16.956 16.956zm0-33.245a16.29 16.29 0 1 0 16.29 16.289A16.307 16.307 0 0 0 16.957.668z",
    fill: "#81B141"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a6a2881c2f89de851aa1a35aab07a98f.svg";
export { ForwardRef as ReactComponent };